import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nosaws'
})
export class NosawsPipe implements PipeTransform {

  transform(value: any): any {
    if(!value) return;
    return value.filter(loc => {
       return (loc.name != 'ON SAW' && loc.name != 'FORKLIFT')
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/inventory/pipes/nosaws-pipe.ts